import { render } from "./FormChangeLiburEo.vue?vue&type=template&id=89bb6976"
import script from "./FormChangeLiburEo.vue?vue&type=script&lang=js"
export * from "./FormChangeLiburEo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__